const mark = action => `ORGANIZATION_HISTORY/${action}`;

export const LOAD_ALL = mark('LOAD_ALL');

export const loadOrganizationHistory = (payload, onSuccess) => ({
  type: LOAD_ALL,
  payload,
  meta: { onSuccess },
});
